import type { UnknownEvent } from '@faststore/sdk'
import { sendAnalyticsEvent } from '@faststore/sdk'
import React, { useState } from 'react'
import Link from 'src/components/ui/Link'

import type { CarouselItemsProps, OffersCarouselProps } from './offers-carousel'

import './offers-carousel.scss'

const OffersCarousel: React.FC<OffersCarouselProps> = ({
  links,
  carouselItems,
  marginTop,
  marginBottom,
  linksCarouselAligment,
  contentCarouselAligment,
}) => {
  const [selectedLink, setSelectedLink] = useState<string>(links[0])

  const handleAnalytics = (href: string) => {
    sendAnalyticsEvent<UnknownEvent>({
      name: 'select_promotion',
      params: {
        promo: href,
      },
    })
  }

  const handleLinkClick = (linkId: string) => {
    handleAnalytics(linkId)
    setSelectedLink(linkId)
  }

  const renderLinks = () => {
    return links.map((link) => {
      const isSelected = link === selectedLink
      const buttonClass = isSelected
        ? 'offers-carousel-container-links__buttons offers-carousel-container-links__buttons--selected'
        : 'offers-carousel-container-links__buttons'

      return (
        <button
          key={link}
          onClick={() => handleLinkClick(link)}
          className={buttonClass}
        >
          {link}
        </button>
      )
    })
  }

  const renderItems = (carouselItemsProps: CarouselItemsProps[]) => {
    return carouselItemsProps.map(
      ({ image, title, colorTitle, text, href }) => (
        <div key={image} className="offers-carousel-container-items-content">
          <Link
            style={{ textDecoration: 'none' }}
            as="a"
            href={href ?? '/'}
            onClick={() => handleAnalytics(href ?? '/')}
          >
            <img
              src={image}
              alt={title ?? 'immagine carosello'}
              className="offers-carousel-container-items__image"
              loading="lazy"
              style={
                !title && !text ? { height: '100%', borderRadius: '8px' } : {}
              }
            />
            {title && text && (
              <div className="offers-carousel-container-items-text">
                <p
                  className="offers-carousel-container-items-text__title"
                  style={{ color: colorTitle ?? '#000000' }}
                >
                  {title}
                </p>
                <p className="offers-carousel-container-items-text__description">
                  {text}
                </p>
              </div>
            )}
          </Link>
        </div>
      )
    )
  }

  const renderSecondCarousel = () => {
    if (!selectedLink) {
      return null
    }

    const selectedItem = carouselItems.find(
      (item) =>
        item.linkId?.toLowerCase().trim() === selectedLink?.toLowerCase().trim()
    )

    if (!selectedItem) {
      return (
        <div className="offers-carousel-container-items-message">
          <p>Non sono stati trovati elementi collegati</p>
        </div>
      )
    }

    return <>{renderItems(selectedItem.carouselItemsProps)}</>
  }

  return (
    <section
      className="offers-carousel"
      style={{
        marginTop: `${marginTop}`,
        marginBottom: `${marginBottom}`,
      }}
    >
      <div className="offers-carousel-container">
        <div
          className="offers-carousel-container-links"
          style={{ justifyContent: `${linksCarouselAligment}` }}
        >
          {renderLinks()}
        </div>
        <div
          className="offers-carousel-container-items"
          style={{ justifyContent: `${contentCarouselAligment}` }}
        >
          {renderSecondCarousel()}
        </div>
      </div>
    </section>
  )
}

export default OffersCarousel
